import { SVGProps } from "react";

export const HornIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.78898 10.5103C3.43612 11.0438 3.23254 11.68 3.23254 12.3615C3.23254 14.2595 4.82178 15.8 6.78424 15.8C8.69784 15.8 10.2586 14.3328 10.3332 12.4976" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.8716 13.8901L2.90953 10.2409C0.36349 9.46461 0.36349 5.92212 2.90953 5.14587L14.8716 1.49667C15.1322 1.41665 15.4104 1.35663 15.6696 1.44065C18.5101 2.36629 18.5101 13.0218 15.6696 13.9461C15.4117 14.0314 15.1322 13.9701 14.8716 13.8901Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);
